/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Compare_GridcraftInputs */

const en_gc_resources_compare_gridcraft = /** @type {(inputs: Gc_Resources_Compare_GridcraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft`)
};

const zh_gc_resources_compare_gridcraft = /** @type {(inputs: Gc_Resources_Compare_GridcraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GridCraft`)
};

/**
* | output |
* | --- |
* | "GridCraft" |
*
* @param {Gc_Resources_Compare_GridcraftInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_compare_gridcraft = /** @type {((inputs?: Gc_Resources_Compare_GridcraftInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Compare_GridcraftInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_compare_gridcraft(inputs)
	return zh_gc_resources_compare_gridcraft(inputs)
});
export { gc_resources_compare_gridcraft as "gc.resources.compare.gridcraft" }